<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
========================================================================================== -->

<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center justify-between">
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          icon="icon-search"
          icon-pack="feather"
          v-model="searchQuery"
          @input="updateSearchQuery"
          :placeholder="$t('SearchUsers')"
        />
        <vs-button
          icon-pack="feather"
          icon="icon-user-plus"
          size="medium"
          class="mb-4 md:mb-0 add-user"
          color="success"
          @click="openAddUser()"
          >{{ $t("AddUser") }}</vs-button
        >
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        :key="componentKey"
        @gridReady="onGridReady"
        id="agGridTable"
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="usersData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="false"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      ></ag-grid-vue>
    </div>

    <vs-popup
      class="holamundo"
      :title="!isEditing ? $t('NewUser') : $t('Edit')"
      :active.sync="popupUser"
    >
      <div class="flex flex-wrap">
        <div class="w-full">
          <p v-if="!isEditing">{{ $t("InviteUser") }}</p>
          <p v-if="!isEditing">
            <vs-input
              name="email"
              v-model="email"
              type="email"
              class="w-full input--lowercase my-3"
              :label="$t('Email')"
            />
          </p>
          <div class="mb-3">
            <small>{{ $t("Type") }}</small>
            <v-select
              id="type"
              v-model="acl"
              :clearable="false"
              :options="aclOptions"
              name="type"
              class="w-full"
            />
          </div>
          <div v-if="hasInbox" class="mb-3">
            <div class="mt-3 ml-1">
              <small>{{ $t("Intention") }}</small>
              <v-select
                id="intentions"
                v-model="intentions"
                :clearable="false"
                :options="inboxIntentions"
                multiple
                name="intentions"
                class="w-full"
              />
            </div>
            <div
              v-if="inboxEntities && inboxEntities.length > 0"
              class="mt-3 ml-1"
            >
              <small>{{ $t("KeyEntities") }}</small>
              <v-select
                id="entities"
                v-model="entities"
                :clearable="false"
                :options="inboxEntities"
                multiple
                name="entities"
                class="w-full"
              />
            </div>
            <div class="ml-1 mt-2" v-if="operatorQueue">
              <small>Na Fila</small>
              <vs-switch color="#28c76f" v-model="inQueue" />
            </div>

            <p v-if="isEditing && $acl.check('master')">
              <vs-input
                name="newpassword"
                v-model="password"
                type="text"
                class="w-full my-3"
                :label="$t('NewPassword')"
              />
            </p>
            <vs-divider />
          </div>
          <div v-if="arrayOperatorsIds.length > 0" class="mb-3">
            <small>ID Operador Integração</small>
            <div
              v-for="(item, i) in arrayOperatorsIds"
              :key="'input' + i"
              class="w-full mb-5"
            >
              <small>{{ item.name }}</small>
              <!-- <vs-input class="w-full" v-model="item.value" /> -->
              <input class="custom-input" v-model="item.value" />
            </div>
          </div>
          <vs-divider />
          <vs-button
            v-if="!isEditing"
            icon-pack="feather"
            icon="icon-user-plus"
            size="medium"
            class="mb-4 md:mb-0"
            @click="createUser()"
            >{{ $t("Add") }}</vs-button
          >

          <vs-button
            v-if="isEditing"
            icon-pack="feather"
            icon="icon-save"
            size="medium"
            class="mb-4 md:mb-0"
            @click="editUser()"
            >{{ $t("Save") }}</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";

// Store Module

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
//import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import vSelect from "vue-select";

export default {
  components: {
    /* eslint-disable vue/no-unused-components */
    AgGridVue,
    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    //CellRendererVerified,
    CellRendererActions,
    "v-select": vSelect,
  },
  data() {
    return {
      password: "",
      currentUser: "",
      isEditing: false,
      componentKey: 0,
      inboxID: null,
      inboxIntentions: [],
      inboxEntities: [],
      acl: { label: "", value: "" },
      aclOptions: [
        {
          label: "Admin",
          value: "admin",
        },
        {
          label: this.$t("Manager"),
          value: "manager",
        },
        {
          label: this.$t("Operator"),
          value: "operator",
        },
      ],
      entities: [],
      intentions: [],
      intentionsOptions: [],
      name: "",
      email: "",
      popupUser: false,
      searchQuery: "",
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: this.$t("Name"),
          field: "name",
          filter: true,
        },
        {
          headerName: this.$t("Email"),
          field: "email",
          filter: true,
        },
        {
          headerName: this.$t("Status"),
          field: "status",
          filter: true,
          cellRenderer: "CellRendererStatus",
        },
        {
          headerName: this.$t("CardActions"),
          field: "_id",
          cellRenderer: "CellRendererActions",
        },
      ],
      components: {
        CellRendererLink,
        CellRendererStatus,
        //CellRendererVerified
        CellRendererActions,
      },
      operatorQueue: false,
      inQueue: false,
      arrayOperatorsIds: [],
    };
  },
  computed: {
    planData: function () {
      return this.$store.state.acc.current_acc.accPlan.plan.planParameters;
    },
    hasInbox: function () {
      return this.planData["inboxAvailable"];
    },
    usersData() {
      const finalData = [];
      if (this.$store.state.acc.current_acc_users)
        this.$store.state.acc.current_acc_users.forEach((el) => {
          const currentEl = JSON.parse(JSON.stringify(el));
          if (currentEl.operatorData) {
            if (
              currentEl.operatorData.entities &&
              currentEl.operatorData.entities.length > 0
            ) {
              let index = currentEl.operatorData.entities.indexOf("__na__");
              if (index > -1)
                currentEl.operatorData.entities[index] = this.$t("NoneEntity");
            } else currentEl.operatorData.entities = [this.$t("All")];
            if (currentEl.operatorData.intentions) {
              let index = currentEl.operatorData.intentions.indexOf("__all__");
              if (index > -1)
                currentEl.operatorData.intentions[index] = this.$t("All");
              index = currentEl.operatorData.intentions.indexOf("");
              if (index > -1)
                currentEl.operatorData.intentions[index] = this.$t("Others");
            }
          }

          finalData.push(currentEl);
        });

      if (finalData.length) {
        this.getArrayOperatorsId();
      }

      return finalData;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    openAddUser() {
      this.isEditing = false;
      this.acl = {};
      this.entities = [];
      this.intentions = [];
      this.currentUser = "";
      this.popupUser = true;
      this.password = "";
      this.inQueue = false;
    },
    openEdit(data) {
      this.acl = {};
      this.entities = [];
      this.intentions = [];
      this.currentUser = "";
      this.password = "";
      this.inQueue = false;
      this.isEditing = true;
      this.currentUser = data._id;
      if (data.operatorData.entities)
        data.operatorData.entities.forEach((el) => {
          const element = this.inboxEntities.find(
            (el2) => el2.value === el || el2.label === el
          );
          this.entities.push(element || { label: el, value: el });
        });
      if (data.operatorData.intentions)
        data.operatorData.intentions.forEach((el) => {
          const element = this.inboxIntentions.find(
            (el2) => el2.value === el || el2.label === el
          );
          this.intentions.push(element || { label: el, value: el });
        });

      let index = this.entities.indexOf("__na__");
      if (index > -1) this.entities[index] = this.$t("NoneEntity");
      index = this.entities.indexOf("__all__");
      if (index > -1) this.entities[index] = this.$t("All");
      index = this.intentions.indexOf("__all__");
      if (index > -1) this.intentions[index] = this.$t("All");

      this.acl = this.aclOptions.find((el) => data.acl === el.value);
      this.inQueue = data.operatorData.inQueue;

      this.popupUser = true;

      // preenche os ids que o operador já tem
      if (this.arrayOperatorsIds.length > 0) {
        for (var i = 0; i < this.arrayOperatorsIds.length; i++) {
          // limpa os valores de arrayOperatorsIds
          this.arrayOperatorsIds[i].value = null;
          if (data.operatorData.integrationIds)
            for (var j = 0; j < data.operatorData.integrationIds.length; j++) {
              if (
                this.arrayOperatorsIds[i].name ==
                data.operatorData.integrationIds[j].name
              ) {
                this.arrayOperatorsIds[i].value =
                  data.operatorData.integrationIds[j].value;
              }
            }
        }
      }
    },
    createUser() {
      let acl = "";
      if (this.acl.value !== undefined) acl = this.acl.value;

      let entities = JSON.parse(JSON.stringify(this.entities));
      let intentions = JSON.parse(JSON.stringify(this.intentions));

      let index = entities.findIndex(
        (el) => el.label === this.$t("NoneEntity")
      );

      if (index > -1) entities[index].value = "__na__";
      index = entities.findIndex((el) => el.label === this.$t("All"));
      if (index > -1) entities.splice(index, 1);

      index = intentions.findIndex((el) => el.label === this.$t("All"));
      if (index > -1) intentions[index].value = "__all__";
      index = intentions.findIndex((el) => el.label === this.$t("Others"));
      if (index > -1) intentions[index].value = "";

      const payload = {
        userDetails: {
          acl: acl,
          intentions: intentions.map((el) => el.value),
          entities: entities.map((el) => el.value),
          email: this.email,
          acc: this.$store.state.acc.current_acc.id,
          inQueue: this.inQueue,
          integrationIds: this.arrayOperatorsIds,
        },
        notify: this.$vs.notify,
      };

      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!re.test(this.email)) {
        this.$vs.notify({
          time: 2500,
          title: this.$t("Error"),
          text: this.$t("InvalidEmail"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      this.$store
        .dispatch("auth/inviteUserJWT", payload)
        .then(() => {
          this.$vs.notify({
            time: 2500,
            title: this.$t("Ok"),
            text: this.$t("UserInvitedSuccessfully"),
            iconPack: "feather",
            icon: "icon-success-circle",
            color: "success",
            position: "top-right",
          });

          this.email = "";
          this.entities = [];
          this.intentions = [];
          this.acl = "";
          this.popupUser = false;

          this.$store
            .dispatch(
              "acc/getAccUserList",
              this.$store.state.acc.current_acc.id
            )
            .then((response) => {
              this.$store.commit("acc/SET_CURRENT_ACC_USERS", response);
            });
        })
        .catch((error) => {
          if (typeof error.request !== "undefined")
            if (typeof error.request.response !== "undefined")
              error.message = JSON.parse(error.request.response).message;

          this.$vs.notify({
            time: 2500,
            title: this.$t("Error"),
            text: error.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
        });
    },
    editUser() {
      let intentions = JSON.parse(JSON.stringify(this.intentions));
      let entities = JSON.parse(JSON.stringify(this.entities));

      let index = entities.findIndex(
        (el) => el.label === this.$t("NoneEntity")
      );

      if (index > -1) entities[index].value = "__na__";
      index = entities.findIndex((el) => el.label === this.$t("All"));
      if (index > -1) entities.splice(index, 1);

      index = intentions.findIndex((el) => el.label === this.$t("All"));
      if (index > -1) intentions[index].value = "__all__";
      index = intentions.findIndex((el) => el.label === this.$t("Others"));
      if (index > -1) intentions[index].value = "";
      this.$http({
        method: "PUT",
        url: `/g/acc/userAccess`,
        data: {
          user: this.currentUser,
          acl: this.acl.value,
          intentions: intentions.map((el) => el.value),
          entities: entities.map((el) => el.value),
          acc: this.$store.state.acc.current_acc.id,
          inQueue: this.inQueue,
          password: this.password,
          integrationIds: this.arrayOperatorsIds,
        },
      })
        .then(() => {
          this.popupUser = false;
          this.$vs.notify({
            title: this.$t("Success"),
            text: this.$t("InformationChanged"),
            iconPack: "feather",
            icon: "icon-success-circle",
            color: "success",
            position: "top-right",
            time: 4000,
          });
          this.$store
            .dispatch(
              "acc/getAccUserList",
              this.$store.state.acc.current_acc.id
            )
            .then((response) => {
              this.$store.commit("acc/SET_CURRENT_ACC_USERS", response);
            });
        })
        .catch((error) => {
          if (error.request != null)
            if (typeof error.request.response !== "undefined")
              error.message =
                JSON.parse(error.request.response).data != null
                  ? Array.isArray(JSON.parse(error.request.response).data)
                    ? JSON.parse(error.request.response).data[0].msg
                    : ""
                  : JSON.parse(error.request.response).message;
          this.$vs.notify({
            title: this.$t("UnexpectedError"),
            text: error.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-right",
            time: 4000,
          });
        });
    },
    updateSearchQuery(val) {
      this.gridOptions.api.setQuickFilter(val);
    },
    onGridReady(params) {
      params.api.sizeColumnsToFit();
    },
    getArrayOperatorsId() {
      // Faz o get das integrações em que se espera ter o operador ID
      this.$http
        .get(`/g/product/apps/list/operatorsId`, {
          params: {
            acc: this.$store.state.acc.current_acc.id,
          },
        })
        .then((response) => {
          if (response.data.data.length) {
            this.arrayOperatorsIds = response.data.data;
          }
        });
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridOptions.context = {
      componentParent: this,
    };

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left =
        "-" + String(Number(header.style.transform.slice(11, -3)) + 9) + "px";
    }
  },
  created() {
    this.$store
      .dispatch("acc/getAccUserList", this.$store.state.acc.current_acc.id)
      .then((response) => {
        this.$store.commit("acc/SET_CURRENT_ACC_USERS", response);
      });

    this.$http
      .get(`/p/chat/inbox/${this.$store.state.acc.current_acc.id}`, {
        params: {
          acc: this.$store.state.acc.current_acc.id,
        },
      })
      .then((response) => {
        const data = response.data.data.inbox;

        if (this.hasInbox) {
          this.operatorQueue = data.operatorQueue;
          this.inboxID = data._id;
          this.inboxIntentions = [
            { label: this.$t("All"), value: "__all__" },
            { label: this.$t("Others"), value: "" },
          ];
          if (data.intentions)
            data.intentions.forEach((el) => {
              if (
                this.inboxIntentions.findIndex((el2) => el2.label === el) === -1
              )
                this.inboxIntentions.push({
                  label: el,
                  value: el,
                });
            });
          this.inboxEntities = [
            { label: this.$t("NoneEntity"), value: "__na__" },
            { label: this.$t("All"), value: "" },
          ];
          if (data.keyEntities) {
            data.keyEntities.forEach((el) => {
              this.inboxEntities.push({
                label: el,
                value: el,
              });
            });
          }

          this.columnDefs.splice(
            3,
            1,
            {
              headerName: this.$t("Intentions"),
              field: "operatorData.intentions",
              filter: true,
            },
            {
              headerName: this.$t("KeyEntities"),
              field: "operatorData.entities",
              filter: true,
            },
            {
              headerName: "Tipo",
              field: "operatorData.acl",
              filter: true,
            },
            {
              headerName: this.$t("CardActions"),
              field: "_id",
              cellRendererParams: {
                inboxID: this.inboxID,
              },
              cellRenderer: "CellRendererActions",
            }
          );
        }
        this.componentKey = Math.ceil(Math.random());
      })
      .catch(() => {
        this.inboxID = 0;
        this.componentKey = 2;
      });
  },
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
.custom-input {
  width: 100%;
  padding: 0.7rem !important;
  font-size: 1rem !important;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;

  &:focus {
    border: 1px solid rgba(var(--vs-primary), 1) !important;
  }
}
</style>
